var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgNotification(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10 12V12.6C10 13.2365 9.78929 13.847 9.41421 14.2971C9.03914 14.7471 8.53043 15 8 15C7.46957 15 6.96086 14.7471 6.58579 14.2971C6.21071 13.847 6 13.2365 6 12.6V12M13.8482 10.9337C12.9735 9.90476 12.3559 9.38095 12.3559 6.5442C12.3559 3.94643 10.9757 3.02092 9.83976 2.57143C9.68886 2.51185 9.54682 2.375 9.50084 2.22604C9.30158 1.57423 8.74296 1 8.00041 1C7.25785 1 6.6989 1.57455 6.50168 2.2267C6.45569 2.37729 6.31366 2.51185 6.16276 2.57143C5.02543 3.02158 3.6466 3.94381 3.6466 6.5442C3.6449 9.38095 3.02735 9.90476 2.15264 10.9337C1.79022 11.36 2.10768 12 2.74157 12H13.2626C13.8931 12 14.2086 11.358 13.8482 10.9337Z",
    stroke: "#8F8E99",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotification);
export default __webpack_public_path__ + "static/media/notification.aa1f42ab680f5db737e626195de5a104.svg";
export { ForwardRef as ReactComponent };